import { gql } from '@apollo/client';
import { AssetWithDimensionsFragment } from '../../graphql/fragments/Asset';

export const TextCardFragment = gql`
  fragment TextCardFragment on TextCard {
    ... on TextCard {
      __typename
      backgroundColor
      ctas {
        id
        text
        title
        url
      }
      customBackgroundColor
      header
      icon {
        ...AssetWithDimensionsFragment
      }
      id
      subheader
      title
    }
  }
  ${AssetWithDimensionsFragment}
`;

export default {};
